import { CATEGORY_META } from "@/components/safety-config/risk-groups";
import type { CatalogRisk } from "./useSafetyConfigState";

export type AdminRiskGroup = {
  id: string;
  name: string;
  risks: CatalogRisk[];
};

// Groups the merged admin catalog into the same category groups (names + order)
// the customer-facing configure page uses. Unlike the customer grouping, rows
// are NOT merged by readable name — the admin edits each risk id individually.
// Unknown categories fall into a trailing group so nothing silently disappears.
// The "custom" group is always emitted, even empty — it hosts the add-a-custom-
// risk controls.
export const groupAdminCatalog = (catalog: CatalogRisk[]): AdminRiskGroup[] => {
  const byCategory = new Map<string, CatalogRisk[]>();
  for (const risk of catalog) {
    const list = byCategory.get(risk.category) ?? [];
    list.push(risk);
    byCategory.set(risk.category, list);
  }

  const groups: AdminRiskGroup[] = [];
  for (const meta of CATEGORY_META) {
    const risks = byCategory.get(meta.id);
    if (risks?.length || meta.id === "custom") groups.push({ id: meta.id, name: meta.name, risks: risks ?? [] });
    byCategory.delete(meta.id);
  }
  for (const [category, risks] of byCategory) {
    groups.push({ id: category, name: category, risks });
  }
  return groups;
};
